import { BUTTON_SUBMISSION, MODULE_CLICK, NOT_APPLICABLE } from '../constants';

export const marketingContentMilitary = () => {
  const publishAnalytics = ( output ) => {
    const { cardType } = output;
    
    const cardData = {
      aafes: {
        id: 'military exchange aafes',
        name: 'military exchange aafes',
      },
      navy: {
        id: 'military exchange navy',
        name: 'military exchange navy',
      }
    };

    const selectedCard = cardData[cardType] || cardData.aafes;

    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION,
      },
      eventInfo: {
        eventName: MODULE_CLICK,
      },
      pageType: 'military exchange',
      content: {
        widgets: [{
          action: 'button click',
          id: selectedCard.id,
          name: selectedCard.name,
          templates: NOT_APPLICABLE,
          campaign: 'shop now',
          component: NOT_APPLICABLE,
          element: 'button'
        }]
      },
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  };

  window.LIFE_CYCLE_EVENT_BUS.on('spotlight.military.content-click', ({ output = {} }) => {
    publishAnalytics( output );
  });
};
